module.exports = __webpack_public_path__ + "img/AL804-2.dd3d1e20.jpg";